import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import * as selectors from 'selectors/pathBuilder';
import * as actions from 'actions/pathBuilder';
import { PATH_MODES } from 'constants/config';
import Header from './Header';
import Sidebar from './Sidebar';
import Reporting from './Reporting';
import ContentList from './ContentList';
import ErrorModal from './ErrorModal';
import DNDScrollZone from '../shared/DNDScrollZone';
import {
  TabbedView,
  Tab,
  TabList,
  TabPanel,
} from '../shared/TabbedView/index.js';

const Tabs = [PATH_MODES.REPORTING, PATH_MODES.VIEW];

const PathBuilder = ({
  isDraggingContent,
  currentMode,
  showTabs,
  setMode,
  hasUpdateError,
}) => {
  return (
    <div className="PathBuilder">
      <DNDScrollZone willReceiveDraggable={isDraggingContent} />
      {hasUpdateError && <ErrorModal />}
      <div className="PathBuilder-main">
        <div className="PathViewer">
          <Header />
          {showTabs && (
            <TabbedView
              selectedIndex={Tabs.indexOf(currentMode)}
              onSelect={tab => setMode(Tabs[tab])}
            >
              <TabList>
                <Tab>{t('paths.path_builder.tabs.reporting')}</Tab>
                <Tab>{t('paths.path_builder.tabs.steps')}</Tab>
              </TabList>
              <TabPanel>
                <Reporting />
              </TabPanel>
              <TabPanel>
                <ContentList />
              </TabPanel>
            </TabbedView>
          )}
          {!showTabs && <ContentList />}
        </div>
      </div>
      <div className="PathBuilder-side">
        <Sidebar />
      </div>
    </div>
  );
};

const mapStateToProps = ({ pathBuilder, ...state }) => ({
  isDraggingContent: pathBuilder.isDraggingContent,
  currentMode: pathBuilder.mode,
  showTabs: selectors.shouldRenderTabs(pathBuilder),
  hasUpdateError: pathBuilder.updateError,
});

const mapDispatchToProps = {
  setMode: actions.setMode,
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  PathBuilder,
);
